import React, { useEffect, useRef, useState } from 'react'
import styles from './DisplayBoard.module.css';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from 'utils/constants';

const BMC = (props) => {
    const [dataLoaded, setDataLoaded] = useState(false);
    // -------------------------------------------------------------------------------
    // -------------------------------------------------------------------------------

    // const revenue_streamsRef = useRef(null)
    // const key_partnersRef = useRef(null)
    const [key_partners, setkey_partners] = useState("")
    const [key_partnersBar, setkey_partnersBar] = useState(0);
    // const key_activitiesRef = useRef(null)
    const [key_activities, setkey_activities] = useState("")
    const [key_activitiesBar, setkey_activitiesBar] = useState(0);
    // const value_propositionRef = useRef(null)
    const [value_proposition, setvalue_proposition] = useState("")
    const [value_propositionBar, setvalue_propositionBar] = useState(0);
    // const customer_relationshipRef = useRef(null)
    const [customer_relationship, setcustomer_relationship] = useState("")
    const [customer_relationshipBar, setcustomer_relationshipBar] = useState(0);
    // const customer_segmentsRef = useRef(null)
    const [customer_segments, setcustomer_segments] = useState("");
    const [customer_segmentsBar, setcustomer_segmentsBar] = useState(0);
    // const key_resourcesRef = useRef(null)
    const [key_resources, setkey_resources] = useState("");
    const [key_resourcesBar, setkey_resourcesBar] = useState(0);

    const [channels, setchannels] = useState("")
    const [channelsBar, setchannelsBar] = useState(0);
    const [cost_structure, setcost_structure] = useState("")
    const [cost_structureBar, setcost_structureBar] = useState(0);

    const [revenue_streams, setrevenue_streams] = useState("")
    const [revenue_streamsBar, setrevenue_streamsBar] = useState(0);

    useEffect(() => {

        Swal.showLoading();
        axios.get(`${BASE_URL}/capstone/displayboard/getbmc.php`)
            .then(res => {
                let hasFailedFlag = true
                if (res?.data?.data) {
                    const res_data_data = res?.data?.data;
                    // console.log("res_data_data")
                    // console.log(res_data_data)
                    if (res_data_data.hasOwnProperty("capstonebmc")) {
                        hasFailedFlag = false
                        const tmp_capstonebmc = res_data_data?.capstonebmc;

                        if (tmp_capstonebmc?.hasOwnProperty("key_partners")) {
                            setkey_partners(tmp_capstonebmc["key_partners"])
                            // if (key_partnersRef?.current) {
                            //     key_partnersRef.current.value = tmp_capstonebmc["key_partners"]
                            // }
                        }

                        if (tmp_capstonebmc?.hasOwnProperty("key_partners_bar")) {
                            setkey_partnersBar(tmp_capstonebmc["key_partners_bar"] ?? 0)
                        }
                        if (tmp_capstonebmc?.hasOwnProperty("key_activities")) {
                            setkey_activities(tmp_capstonebmc["key_activities"] ?? 0)
                            // if (key_activitiesRef?.current) {
                            //     key_activitiesRef.current.value = tmp_capstonebmc["key_activities"]
                            // }
                        }

                        if (tmp_capstonebmc?.hasOwnProperty("key_activities_bar")) {
                            setkey_activitiesBar(tmp_capstonebmc["key_activities_bar"] ?? 0)
                        }


                        if (tmp_capstonebmc?.hasOwnProperty("revenue_streams")) {
                            setrevenue_streams(tmp_capstonebmc["revenue_streams"] ?? 0)
                            // if (revenue_streamsRef?.current) {
                            //     revenue_streamsRef.current.value = tmp_capstonebmc["revenue_streams"]
                            // }
                        }

                        if (tmp_capstonebmc?.hasOwnProperty("revenue_streams_bar")) {
                            setrevenue_streamsBar(tmp_capstonebmc["revenue_streams_bar"] ?? 0)
                        }


                        // -------------------------------------------------------------------------------
                        if (tmp_capstonebmc?.hasOwnProperty("channels")) {
                            setchannels(tmp_capstonebmc["channels"]??"")
                        }
                        if (tmp_capstonebmc?.hasOwnProperty("channels_bar")) {
                            setchannelsBar(tmp_capstonebmc["channels_bar"] ?? 0)
                        }
                        // -------------------------------------------------------------------------------
                        if (tmp_capstonebmc?.hasOwnProperty("cost_structure")) {
                            setcost_structure(tmp_capstonebmc["cost_structure"] ?? "")
                        }
                        if (tmp_capstonebmc?.hasOwnProperty("cost_structure_bar")) {
                            setcost_structureBar(tmp_capstonebmc["cost_structure_bar"] ?? 0)
                        }
                        if (tmp_capstonebmc?.hasOwnProperty("value_proposition")) {
                            setvalue_proposition(tmp_capstonebmc["value_proposition"] ?? 0)
                        }

                        if (tmp_capstonebmc?.hasOwnProperty("value_proposition_bar")) {
                            setvalue_propositionBar(tmp_capstonebmc["value_proposition_bar"] ?? 0)
                        }
                        if (tmp_capstonebmc?.hasOwnProperty("customer_relationship")) {
                            setcustomer_relationship(tmp_capstonebmc["customer_relationship"] ?? 0)
                        }

                        if (tmp_capstonebmc?.hasOwnProperty("customer_relationship_bar")) {
                            setcustomer_relationshipBar(tmp_capstonebmc["customer_relationship_bar"] ?? 0)
                        }
                        if (tmp_capstonebmc?.hasOwnProperty("customer_segments")) {
                            setcustomer_segments(tmp_capstonebmc["customer_segments"] ?? 0)
                        }

                        if (tmp_capstonebmc?.hasOwnProperty("customer_segments_bar")) {
                            setcustomer_segmentsBar(tmp_capstonebmc["customer_segments_bar"] ?? 0)
                        }
                        if (tmp_capstonebmc?.hasOwnProperty("key_resources")) {
                            setkey_resources(tmp_capstonebmc["key_resources"] ?? 0)
                        }

                        if (tmp_capstonebmc?.hasOwnProperty("key_resources_bar")) {
                            setkey_resourcesBar(tmp_capstonebmc["key_resources_bar"] ?? 0)
                        }


                    }
                }
                if (hasFailedFlag) {
                    Swal.fire("Sorry, try again later", "", "error")
                } else {
                    Swal.close();
                    setDataLoaded(true)
                }
            }).catch(err => {
                // console.log("err")
                Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

            })


        return () => {

        }
    }, [])


    const handleSend = (field, text, bar) => {
        if (text?.trim() !== "") {
            // // console.log("globalState?.permissions?.fullname")
            // // console.log(props.globalState?.permissions?.id)
            // globalState?.permissions?.fullname

            Swal.showLoading();
            axios.post(`${BASE_URL}/capstone/displayboard/setbmc.php`, {
                field: field,
                content: text,
                bar
            })
                .then(res => {
                    let hasFailedFlag = true
                    if (res?.data?.data) {
                        const res_data_data = res?.data?.data;
                        // // console.log("res_data_data")
                        // // console.log(res_data_data)
                        if (res_data_data.hasOwnProperty("ok")) {
                            hasFailedFlag = false
                            Swal.fire("Saved", "", "success")
                        }
                    }
                    if (hasFailedFlag) {
                        Swal.fire("Sorry, try again later", "", "error")
                    }
                }).catch(err => {
                    Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

                })


        }
    };


    if (!dataLoaded) {
        return <h2>Loading...</h2>
    } else {
        return (
            <div>
                <h2 className={styles.capstone_idea_status} >Business Model Canvas</h2>
                <p style={{ color: "red" }} >*Note that the "Save" button is for the whole section , so if you modify either of the slider or the text you need to push it.</p>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Key Partners</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                value={key_partnersBar}
                                onChange={e => {
                                    setkey_partnersBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{key_partnersBar}%</span>
                            </span>
                        </div>
                    </div>

                    <textarea className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        // ref={key_partnersRef}
                        value={key_partners}
                        onChange={e => { setkey_partners(e?.target?.value) }}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "key_partners"
                                const text = key_partners
                                const bar = key_partnersBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Key Activities</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                value={key_activitiesBar}
                                onChange={e => {
                                    setkey_activitiesBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{key_activitiesBar}%</span>
                            </span>
                        </div>
                    </div>

                    <textarea className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        // ref={key_activitiesRef}
                        value={key_activities}
                        onChange={e => { setkey_activities(e?.target?.value) }}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "key_activities"
                                const text = key_activities
                                const bar = key_activitiesBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Value Proposition</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"

                                style={{
                                    width: "90px",
                                }}
                                value={value_propositionBar}
                                onChange={e => {
                                    setvalue_propositionBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{value_propositionBar}%</span>
                            </span>
                        </div>
                    </div>

                    <textarea className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        // ref={value_propositionRef}
                        value={value_proposition}
                        onChange={e => { setvalue_proposition(e?.target?.value) }}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >


                        <button className='btn btn-primary'

                            onClick={(e) => {
                                const field = "value_proposition"
                                const text = value_proposition
                                const bar = value_propositionBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Customer Relationship</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"

                                style={{
                                    width: "90px",
                                }}
                                value={customer_relationshipBar}
                                onChange={e => {
                                    setcustomer_relationshipBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{customer_relationshipBar}%</span>
                            </span>
                        </div>
                    </div>

                    <textarea className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        // ref={customer_relationshipRef}
                        value={customer_relationship}
                        onChange={e => { setcustomer_relationship(e?.target?.value) }}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >
                        <button className='btn btn-primary'

                            onClick={(e) => {
                                const field = "customer_relationship"
                                const text = customer_relationship
                                const bar = customer_relationshipBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >


                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Customer Segments</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"

                                style={{
                                    width: "90px",
                                }}
                                value={customer_segmentsBar}
                                onChange={e => {
                                    setcustomer_segmentsBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{customer_segmentsBar}%</span>
                            </span>
                        </div>
                    </div>

                    <textarea className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        // ref={customer_segmentsRef}
                        value={customer_segments}
                        onChange={e => { setcustomer_segments(e?.target?.value) }}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        <button className='btn btn-primary'

                            onClick={(e) => {
                                const field = "customer_segments"
                                const text = customer_segments
                                const bar = customer_segmentsBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Key resources (Hardware tools)</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                value={key_resourcesBar}
                                onChange={e => {
                                    setkey_resourcesBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{key_resourcesBar}%</span>
                            </span>
                        </div>
                    </div>
                    <textarea className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        // ref={key_resourcesRef}
                        value={key_resources}
                        onChange={e => { setkey_resources(e?.target?.value) }}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >
                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "key_resources"
                                const text = key_resources
                                const bar = key_resourcesBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    {/* <div className={styles.title} >
                        < h4 className={styles.titleH1} >Selected Solution</ h4>
                    </div> */}

                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Methods and Materials</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                value={channelsBar}
                                onChange={e => {
                                    setchannelsBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{channelsBar}%</span>
                            </span>
                        </div>
                    </div>

                    <textarea className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        defaultValue={channels}
                        onChange={(e)=>{setchannels(e.target.value)}}
                    />

                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "channels"
                                const text = channels
                                const bar = channelsBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Results and data analysis</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                // className='capstonebmcSectionInput'
                                value={cost_structureBar}
                                onChange={e => {
                                    setcost_structureBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{cost_structureBar}%</span>
                            </span>
                        </div>
                    </div>
                    <textarea className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        defaultValue={cost_structure}
                        onChange={(e)=>{setcost_structure(e.target.value)}}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >
                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "cost_structure"
                                const text = cost_structure
                                const bar = cost_structureBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}


                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Revenue Streams</ h4>

                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                value={revenue_streamsBar}
                                onChange={e => {
                                    setrevenue_streamsBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{revenue_streamsBar}%</span>
                            </span>
                        </div>
                    </div>

                    <textarea className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        value={revenue_streams}
                        onChange={e => { setrevenue_streams(e?.target?.value) }}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "revenue_streams"
                                const text = revenue_streams
                                const bar = revenue_streamsBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}


            </div >
        )
    }
}

export default BMC